
import PersonData from "./data/PersonalData";

function SelectedPlan() {
  return(
    <PersonData />
  )
}
export default SelectedPlan;
